module.exports = __webpack_public_path__ + "img/40_38_056_810.3fb1404b.jpg";